export const selectDeliverymanProducts = ({ deliverymanProducts: { get } }) => get;
export const selectSearchProducts = ({ deliverymanProducts: { search } }) => search;
export const selectProducts = ({ deliverymanProducts: { getProducts } }) => getProducts;
export const selectDeliverymanProductsSet = ({ deliverymanProducts: { set } }) => set;
export const selectDeliverymanProductsClear = ({ deliverymanProducts: { clear } }) => clear;
export const selectSavedProducts = ({ deliverymanProducts: { saveProductWarehouse } }) => saveProductWarehouse.data;
